
import { Criteria, Geojson } from '../../utility/Types/commonTypes';
import { FETCH_LAYERS_SUCCESS } from '../layers/Types';
import { ISearchAction } from '../search/searchTypes';
import { v4 as uuidv4 } from 'uuid';

import {
    SET_AREA_FACET,
    SET_AREA_FACET_VALUE,
    SET_AREA_GEOJSON,
    SET_AREA_CRITERIA_ADVANCED_MODE,
    SET_AREA_CRITERIA,
    SET_AREA_LAYER,
    SET_FORM_PROPERTIES,
    CLEAR_AREA
} from './Types';
import _ from 'lodash';
import CleanCriteria from './CleanCriteria';

const defaultCriteria: Criteria = {
    id: 'root',
    type: 'group',
    conjunction: 'and',
    not: false,
    children: []
};

const defaultState: {
    isDirty: boolean;
    geojson: Geojson | null;
    facetId: number | null;
    facetValue: string | null;
    facetValid: boolean;
    isCriteriaAdvancedMode: boolean;
    criteria: Criteria;
    layerId: number | null;
} = {
    isDirty: false,
    // The cache area stored as geojson
    geojson: null,
    // The type of area, support for layer type 'drawn' and 'fixed'. 
    facetId: null,
    // The value of the facet, for fixed is the inputted value to filter against, for drawn is 'circle' or 'polygon'
    facetValue: null,
    // Additional helper to indicate the area is valid based on facet (not taking into consent max area or feature restrictions), could just use if area exists as the check
    facetValid: false,

    isCriteriaAdvancedMode: false,
    criteria: _.cloneDeep(defaultCriteria),
    layerId: null
};

export default function higherOrderReducer (name = '') {
    return function reducer (state = defaultState, action: ISearchAction) {
        // Actions that will run for every copy of this reducer
        switch (action.type) {
            case CLEAR_AREA:
                return _.cloneDeep(defaultState);
        }
        if (action.reducerName !== name) return state;
        // Actions that will only run for the specifically named reducer
        switch (action.type) {
            case SET_FORM_PROPERTIES:
                return {
                    ...state,
                    ...action.props,
                    isDirty: true
                };
            case SET_AREA_LAYER:
                return {
                    ...state,
                    layerId: action.layerId,
                    facetId: null,
                    facetValue: null,
                    facetValid: false,
                    criteria: action.criteria,
                    isCriteriaAdvancedMode: action.isCriteriaAdvancedMode,
                    isDirty: true
                };
            case SET_AREA_FACET:
                return {
                    ...state,
                    facetId: action.facetId,
                    facetValue: null,
                    facetValid: false,
                    isDirty: true
                };
            case SET_AREA_FACET_VALUE:
                return {
                    ...state,
                    facetValue: action.value,
                    isDirty: true
                };
            case SET_AREA_GEOJSON:
                return {
                    ...state,
                    geojson: action.geojson,
                    facetValid: action.geojson ? true : false,
                    isDirty: true
                };
            case SET_AREA_CRITERIA_ADVANCED_MODE:
                // When going from advanced to simple mode, reset criteria
                return {
                    ...state,
                    criteria: action.criteria,
                    isCriteriaAdvancedMode: action.isAdvanced,
                    isDirty: _.isEqual(action.criteria, state.criteria) ? state.isDirty : true
                }
            case SET_AREA_CRITERIA:
                let criteria = _.cloneDeep(action.criteria);
                let children = criteria.children?.map((e: any)=>(_.omit(e, ['isValid']))); //remove custom isValid flag from objects
                criteria.children = children;

                return {
                    ...state,
                    criteria: _.cloneDeep(action.criteria), //need to clone object to deny reference sharing
                    isDirty: true
                };
            default:
                return state;
        }
    };
}